/* eslint-disable spaced-comment */
/* eslint-disable no-console */
const hasPermission = {
    install (Vue, options) {
        Vue.directive('hasPermission', {
            bind (el, binding, vnode) {
                let permissionList = vnode.context.$route.meta.permission;
                //console.info(JSON.stringify(el));
                //console.info(Object.keys(permissionList));
                if (Object.keys(permissionList).length == 0 || !Object.keys(permissionList).includes(binding.value)) {
                    //el.parentNode.removeChild(el);
                    el.style.display = 'none';
                }
            }
        });
    }
};

export default hasPermission;
